import React, { Component } from 'react';
import './UpdateDrugPopup.css';
import Popup from '../../components/popup/Popup';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import Volume from '../../components/volume/Volume';
import mainAPI from '../../api/MainAPI';
import Button from '../../components/button/Button';
import moment from 'moment';
import Card from '../../components/card/Card';
import toasts from '../../utils/toasts';
import utils from '../../utils/utils';
import models from '../../model/models';
import cloneDeep from 'lodash.clonedeep';
import DiscrepancyPopup from '../discrepancyPopup/DiscrepancyPopup';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import { getDisplayUnit } from '../../utils/gramUtils';

export default class UpdateDrugPopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			codeError: false,
			codeTouched: false,
			update: false,
			drug: props.drug,
			updatedDrug: props.drug
		};
	}
	componentDidMount = async () => {
		const drug = this.state.drug || {};
		const response  = await mainAPI.drug_type.is_short_date_allowed(drug.type);
		this.setState({allow_short_date:response.allowed})
	};

	_throwCodeValid = (bool) => {
		this.setState({
			codeError: bool
		});
	};

	_codeFieldTouched = () => {
		this.setState({
			codeTouched: true
		});
	};

	_updateDrug = async () => {
		const { updatedDrug, codeError, drug } = cloneDeep(this.state);
		if (!updatedDrug.expiration_date) {
			return toasts.show('You need to set an expiration date');
		}
		if (codeError) return;
		if (drug.stock_move_record__quantity != updatedDrug.stock_move_record__quantity) {
			return window.popupController.show(DiscrepancyPopup, {
				title: 'Are you sure you want to change the dosage?',
				notesPlaceholder: 'Why is the dosage changing?',
				onComplete: this._finish
			});
		}
		return this._finish();
	};
	_finish = async (options) => {
		const { updatedDrug } = cloneDeep(this.state);
		if (options && options.notes) updatedDrug.notes = options.notes;
		updatedDrug.expiration_date = utils.client_to_server_date(updatedDrug.expiration_date);
		if(updatedDrug.short_date){
			updatedDrug.short_date = utils.client_to_server_date(updatedDrug.short_date);
		}
		updatedDrug.stock_move_record__quantity = Volume.toMicrograms(
			updatedDrug.stock_move_record__quantity,
			updatedDrug.type
		);
		await models.drug.save({ ...updatedDrug });
		this.props.onClose();
		return true;
	};

	_onHandleChange = async (field, value) => {
		const { updatedDrug } = this.state;
		if (field === 'barcode_id') {
			this._throwCodeValid(value.length < 3);
		}
		const state = {updatedDrug: { ...updatedDrug, [field]: value }};
		if(field ==='type') {
			const response = await mainAPI.drug_type.is_short_date_allowed(value);
			state.allow_short_date = response.allowed;
			if(!response.allowed){
				state.updatedDrug.short_date = null;
			}
		}
		this.setState({
			...state
		});
	};

	render() {
		const {
			codeError,
			codeTouched,
			allow_short_date,
			updatedDrug: { type, barcode_id, drug_box_id, lot_number, expiration_date, short_date, stock_move_record__quantity } = {}
		} = this.state;
		return (
			<Popup {...this.props} show className="g-update-drug-popup">
				<Card>
					<Label className="header" large black>
						Update Drug
					</Label>
					<div className="update-container">
						<div>
							<div className="update field">
								<Label className="update field label" gray-medium>
									Code
								</Label>
								<Input
									className={codeError && codeTouched ? 'update field error' : ''}
									onBlur={this._codeFieldTouched}
									onChange={(e) => {
										this._onHandleChange('barcode_id', e);
									}}
									value={barcode_id}
								/>
								{codeError && (codeTouched && <div className="update field error text">Drug code too short</div>)}
							</div>
							<div className="update field">
								<Label className="update field label" gray-medium>
									Dosage {getDisplayUnit(type)}
								</Label>
								<Input
									type="number"
									onChange={(e) => {
										this._onHandleChange('stock_move_record__quantity', e);
									}}
									value={stock_move_record__quantity}
								/>
							</div>
							<div className="update field">
								<Label className="update field label" gray-medium>
									Lot Number
								</Label>
								<Input
									onChange={(e) => {
										this._onHandleChange('lot_number', e);
									}}
									value={lot_number}
								/>
							</div>
						</div>
						<div>
							<div className="update field">
								<Label className="update field label" gray-medium>
									Expires On
								</Label>
								<Input
									type="date"
									onChange={(e) => {
										this._onHandleChange('expiration_date', e);
									}}
									value={moment(expiration_date).format('YYYY-MM-DD')}
								/>
								{allow_short_date && <>
									<Label className="update field label" gray-medium>
										Short Date
									</Label>
									<Input
									type="date"
									onChange={(e) => {
										this._onHandleChange('short_date', e);
									}}
									value={moment(short_date).format('YYYY-MM-DD')}
								/></>}
							</div>
							<div className="update field">
								<Label className="update field label" gray-medium>
									Drug Box
								</Label>
								<UniversalDropDown
									value={drug_box_id}
									onChange={(e) => {
										this._onHandleChange('drug_box_id', e);
									}}
									endpoint={mainAPI.drug_box.all}
								/>
							</div>
							<div className="update field">
								<Label className="update field label" gray-medium>
									Type
								</Label>
								<UniversalDropDown
									endpoint={mainAPI.drug_type.allowed_drugs}
									onChange={(e) => {
										this._onHandleChange('type', e);
									}}
									value={type}
								/>
							</div>
						</div>
					</div>
					<div className="actions">
						<Button className="button" color="white" bg="red" onClick={this.props.onClose}>
							Cancel
						</Button>
						<Button className="button" color="white" bg="blue" onClick={this._updateDrug}>
							Save
						</Button>
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/updateDrugPopup/UpdateDrugPopup.jsx